import { useAuth } from '@/store/useAuth';
import { routesApp } from '@/constans/routes';
import { generatePath } from 'react-router-dom';

export const useSignUpRedirect = () => {
    const { user } = useAuth((state) => state)

    const generateSignUpPath = () => {
        let design = user?.registration_design
        return generatePath(
            design === 'new_skip_steps' ?
                routesApp.registrationV4
            : design === 'new_photo_last' ?
                routesApp.registrationV3
            : design === 'new' ?
                routesApp.registrationV2
            :
                routesApp.registration,
            { stepNumer: '1' }
        );
    }

    return {
        generateSignUpPath
    }
};
